import React, { useEffect, useRef } from "react";

/**
 * HeroCursorGlow
 *  Soft radial glow that follows the cursor over the hero — adds a
 *  cinematic, premium feel. Uses a single absolutely positioned div and
 *  mutates its transform via rAF (no state writes during motion).
 */
export default function HeroCursorGlow({ color = "rgba(125, 221, 246, 0.16)" }) {
  const wrapRef = useRef(null);
  const dotRef = useRef(null);
  const target = useRef({ x: 0, y: 0 });
  const current = useRef({ x: 0, y: 0 });
  const raf = useRef(0);

  useEffect(() => {
    const wrap = wrapRef.current;
    const dot = dotRef.current;
    if (!wrap || !dot) return;

    const rect = () => wrap.getBoundingClientRect();
    const r = rect();
    target.current = { x: r.width / 2, y: r.height / 2 };
    current.current = { ...target.current };

    const onMove = (e) => {
      const b = rect();
      target.current.x = e.clientX - b.left;
      target.current.y = e.clientY - b.top;
    };

    const loop = () => {
      current.current.x += (target.current.x - current.current.x) * 0.08;
      current.current.y += (target.current.y - current.current.y) * 0.08;
      dot.style.transform = `translate3d(${current.current.x - 260}px, ${current.current.y - 260}px, 0)`;
      raf.current = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove);
    raf.current = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return (
    <div ref={wrapRef} className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      <div
        ref={dotRef}
        className="absolute w-[520px] h-[520px] rounded-full blur-3xl"
        style={{ background: color, transform: "translate3d(0,0,0)" }}
      />
    </div>
  );
}
